export const locale = {
    lang: 'es',
    data: {
      'EDITOR': {
        'ACERCADE': 'Opcionalmente, antes de crear la encuesta puede editar algunas características de la misma, los cambios realizados podrán ser visualizados dentro de la encuesta una vez accediendo a esta.',
        'CONCAMBIOS': 'Se detectaron cambios a la configuración de la encuesta, primero debe generar la encuesta para que se apliquen los cambios realizados, posteriormente podrá completar el paso',
        'CARGANDO': 'Cargando información',
        'GUARDANDO': 'Guardando cambios',
        'CONFIGADICIONAL': {
          'TITULO': 'Configuración adicional',
          'SUBTITULO': 'Esta configuración se aplica a la encuesta para todos los idiomas',
          'DISPONIBLES': 'Controles disponibles',
          'SAVEOK': 'La configuración se actualizó correctamente',
          'CONTROLES': {
            'PIN': 'Activar la protección de encuestas con PIN de usuario',
            'RANDOM': 'Habilitar la pregunta de validación aleatoria',
            'LIDERES': 'Mostrar nombres de líderes (CEO / Jefe) en las perspectivas de reactivos'
          }
        },
        'ELEMENTOS': {
          'GUIA': 'Elementos de este bloque',
          'COLORES': {
            'ORIGINAL': 'Elemento sin modificar',
            'MODIFICADO': 'Elemento modificado'
          },
          'TOOLTIPS': {
            'ORIGINAL': 'Ningún elemento ha sido modificado',
            'MODIFICADO': 'Uno o más elementos han sido modificados',
            'COMPLETO': 'Todos los elementos han sido modificados'
          },
          'ETIQUETAS': {
            'IMAGEN': {
              'NOHAY': 'No hay una imagen',
              'ACTUAL': 'Imagen actual'
            },
            'TEXTO': {
              'INGRESAR': 'Ingrese el texto'
            }
          },
          'BOTONES': {
            'ENTRAR': 'Editar características de la encuesta',
            'REGRESAR': 'Regresar',
            'CONTINUAR': 'Continuar',
            'CANCELAR': 'Cancelar',
            'GUARDAR': 'Guardar cambios',
            'IMAGEN': 'Cambiar imagen',
            'EDITOR': 'Editar mensaje',
            'ELEMENTOS': 'Ayuda',
            'ACTIVAR': 'Mostrar',
            'DESACTIVAR': 'Ocultar',
            'ACEPTAR': 'Aceptar',
          }
        },
        'PANTALLAS': {
          'LOGIN': {
            'TITULO': 'Inicio de sesión',
            'PASOS': {
              'LOGO': {
                'TITULO': 'Logo del broker',
                'ELEMENTOS': {
                  'logo': 'Puede cargar una imagen para cambiar el logo del broker'
                }
              },
              'INSTRUCCIONES': {
                'TITULO': 'Instrucciones previas',
                'ELEMENTOS': {
                  'text': 'Puede escribir las instrucciones a mostrar previo a entrar a la encuesta'
                }
              },
              'LOGINFORM': {
                'TITULO': 'Formulario de inicio de sesión',
                'ELEMENTOS': {
                  'inputPlaceHolderPass': 'Puede cambiar el texto de sugerencia para el campo de "contraseña"',
                  'buttons_login_label': 'Puede cambiar el texto del botón de inicio de sesión',
                  'recoveryAccessKey_text': 'Puede cambiar el texto del botón para recuperar la contraseña',
                }
              },
              'BACKGROUND': {
                'TITULO': 'Imagen de fondo',
                'ELEMENTOS': {
                  'backgroudImage': 'Puede cambiar la imagen de fondo que aparece en esta pantalla',
                }
              },
            }
          },
          'GENERICOS': {
            'TITULO': 'Elementos genéricos',
            'PASOS': {
              'LOGO': {
                'TITULO': 'Logo del broker',
                'ELEMENTOS': {
                  'logo': 'Puede cargar una imagen para cambiar el logo del broker'
                }
              },
              'HEADER': {
                'TITULO': 'Elementos de cabecera',
                'ELEMENTOS': {
                  'buttons_logout_label': 'Puede cambiar el texto del botón de inicio de sesión',
                  'header_logo': 'Puede cambiar la imagen del logo del sistema',
                  'isShowLastLogin_active': 'Puede elegir entre mostrar u ocultar la fecha del último acceso',
                  'backgroundImage': 'Puede cambiar la imagen de fondo que aparece en esta pantalla',
                  'header_showUserName': 'Puede elegir entre mostrar u ocultar el nombre del usuario'
                }
              },
            }
          },
          'BIENVENIDA': {
            'TITULO': 'Pantalla de bienvenida',
            'PASOS': {
              'CONTENIDO': {
                'TITULO': 'Contenido de la pantalla',
                'ELEMENTOS': {
                  'text': 'Puede modificar el contenido de la pantalla de bienvenida',
                  'buttons_next_label': 'Puede cambiar el texto del botón para continuar',
                }
              },
              'LOGOUT': {
                'TITULO': 'Mensaje al cerrar sesión',
                'ELEMENTOS': {
                  'title': 'Puede cambiar el título del mensaje',
                  'text': 'Puede cambiar el texto del mensaje',
                  'buttons_cancel_label': 'Puede cambiar el texto del botón para cancelar la acción',
                  'buttons_logout_label': 'Puede cambiar el texto del botón para cerrar sesión',
                }
              },
            }
          },
          'INSTRUCCIONES': {
            'TITULO': 'Pantalla de instrucciones',
            'PASOS': {
              'CONTENIDO': {
                'TITULO': 'Contenido de la pantalla',
                'ELEMENTOS': {
                  'text': 'Puede modificar el contenido de la pantalla de instrucciones',
                  'buttons_previous_label': 'Puede cambiar el texto del botón para regresar',
                  'buttons_start_label': 'Puede cambiar el texto del botón para iniciar',
                  'buttons_continue_label': 'Puede cambiar el texto del botón para continuar',
                }
              },
              'LOGOUT': {
                'TITULO': 'Mensaje al cerrar sesión',
                'ELEMENTOS': {
                  'title': 'Puede cambiar el título del mensaje',
                  'text': 'Puede cambiar el texto del mensaje',
                  'buttons_cancel_label': 'Puede cambiar el texto del botón para cancelar la acción',
                  'buttons_logout_label': 'Puede cambiar el texto del botón para cerrar sesión',
                }
              },
            }
          },
          'TERMINOS': {
            'TITULO': 'Mensaje de aceptación de encuesta',
            'PASOS': {
              'ACTIVAR': {
                'TITULO': 'Activar el mensaje para aceptar o rechazar la encuesta',
                'ELEMENTOS': {
                  'active': 'Activar el mensaje previo a comenzar'
                }
              },
              'CONTENIDO': {
                'TITULO': 'Contenido del mensaje',
                'ELEMENTOS': {
                  'header_title': 'Puede cambiar el título del mensaje',
                  'text': 'Puede cambiar el contenido del mensaje',
                  'buttons_previous_label': 'Puede cambiar el texto del botón para regresar',
                  'buttons_acept_label': 'Puede cambiar el texto del botón para rechazar la encuesta',
                  'buttons_cancel_label': 'Puede cambiar el texto del botón para aceptar la encuesta'
                }
              },
              'LOGOUT': {
                'TITULO': 'Mensaje al cerrar sesión',
                'ELEMENTOS': {
                  'title': 'Puede cambiar el título del mensaje',
                  'text': 'Puede cambiar el texto del mensaje',
                  'buttons_cancel_label': 'Puede cambiar el texto del botón para cancelar la acción',
                  'buttons_logout_label': 'Puede cambiar el texto del botón para cerrar sesión',
                }
              },
              'NOACEPT': {
                'TITULO': 'Mensaje al rechazar la encuesta',
                'ELEMENTOS': {
                  'title': 'Puede cambiar el título del mensaje',
                  'text': 'Puede cambiar el texto del mensaje',
                  'buttons_saveAndExit_label': 'Puede cambiar el texto del botón para confirmar y salir',
                }
              },
            }
          },
          'SURVEY': {
            'TITULO': 'Pantalla de encuesta',
            'PASOS': {
              'NAV': {
                'TITULO': 'Botones de navegación',
                'ELEMENTOS': {
                  'buttons_next_label': 'Puede cambiar el texto del botón para continuar',
                  'buttons_previous_label': 'Puede cambiar el texto del botón para regresar',
                  'buttons_finish_label': 'Puede cambiar el texto del botón para finalizar la encuesta',
                }
              },
              'INSTRUCCIONES': {
                'TITULO': 'Panel lateral de instrucciones',
                'ELEMENTOS': {
                  'button_label': 'Puede cambiar el texto del botón para mostrar el panel de instrucciones',
                  'active': 'Puede elegir entre mostrar u ocultar el botón del panel de instrucciones',
                  'text': 'Puede modificar el contenido de la pantalla de instrucciones',
                }
              },
              'SOPORTE': {
                'TITULO': 'Panel lateral de tips de soporte',
                'ELEMENTOS': {
                  'button_label': 'Puede cambiar el texto del botón para mostrar el panel de tips de soporte',
                  'active': 'Puede elegir entre mostrar u ocultar el botón del panel de tips de soporte',
                  'text': 'Puede modificar el contenido de la pantalla de tips de soporte',
                }
              },
              'COLUMNA1': {
                'TITULO': 'Reactivos: Perspectiva 1',
                'ELEMENTOS': {
                  'title': 'Puede cambiar el título de la columna de la perspectiva 1',
                  'tooltip_active': 'Puede elegir entre mostrar u ocultar el tooltip del título de la columna',
                  'tooltip_text': 'Puede modificar el contenido del tooltip del título de la columna',
                }
              },
              'COLUMNA2': {
                'TITULO': 'Reactivos: Perspectiva 2',
                'ELEMENTOS': {
                  'title': 'Puede cambiar el título de la columna de la perspectiva 2',
                  'tooltip_active': 'Puede elegir entre mostrar u ocultar el tooltip del título de la columna',
                  'tooltip_text': 'Puede modificar el contenido del tooltip del título de la columna',
                }
              },
              'FINISH_1': {
                'TITULO': 'Mensaje al finalizar la encuesta',
                'ELEMENTOS': {
                  'title': 'Puede cambiar el título del mensaje',
                  'textAnswered': 'Puede modificar el texto del mensaje mostrado al responder todas las preguntas',
                  'textNotAnswered': 'Puede modificar el texto del mensaje mostrado al no responder todas las preguntas',
                  'textFooter': 'Puede modificar el texto del mensaje',
                  'buttons_previous_label': 'Puede cambiar el texto del botón para regresar',
                  'buttons_close_label': 'Puede cambiar el texto del botón para finalizar la encuesta',
                }
              },
              'FINISH_2': {
                'TITULO': 'Mensaje tras finalizar la encuesta',
                'ELEMENTOS': {
                  'windowFinishMessage_title': 'Puede cambiar el título del mensaje',
                  'windowFinishMessage_text': 'Puede modificar el texto del mensaje',
                  'windowRanking_active': 'Puede elegir entre mostrar u ocultar el mensaje para calificar la encuesta',
                  'windowRanking_text': 'Puede modificar el texto del mensaje para calificar la encuesta',
                  'windowFinishMessage_buttons_close_label': 'Puede cambiar el texto del botón para continuar',
                }
              },
              'LOGOUT_1': {
                'TITULO': 'Mensaje al cerrar sesión',
                'ELEMENTOS': {
                  'title': 'Puede cambiar el título del mensaje',
                  'text': 'Puede modificar el texto del mensaje',
                  'textBandRequired': 'Puede modificar el texto del mensaje de advertencia de irreversibilidad',
                  'buttons_previous_label': 'Puede cambiar el texto del botón para cancelar la acción',
                  'buttons_saveAndExit_label': 'Puede cambiar el texto del botón para guardar cambios y cerrar sesión',
                }
              },
              'LOGOUT_2': {
                'TITULO': 'Mensaje tras cerrar sesión',
                'ELEMENTOS': {
                  'title': 'Puede cambiar el título del mensaje',
                  'text': 'Puede modificar el texto del mensaje',
                  'buttons_close_label': 'Puede cambiar el texto del botón para continuar',
                }
              },
            }
          },
        }
      }
    }
};
